
import { defineComponent } from "vue";
export default defineComponent({
  name: "rate-card",
  props: {
    name: String,
    rate: Number,
  },
});
